import cx from 'classnames';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import React, { Component } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import validator from 'validator/es';

import { media } from '../../../styles/media';
import { Button } from '../../ui';
import { getGCLIDParam, getUTMParam } from '../contactFormUtil';

const Section = styled.section`
  .form--element--select.color--white .react-select__single-value {
    color: var(--white) !important;
  }
  .form--element--terms--checkbox {
    inset-inline-start: 0;
  }
  .iti__selected-flag {
    padding: 0;
  }
  .country--holder {
    display: flex;
    align-items: flex-end;
    padding: 0 0 26px;
    padding-inline-end: 8px;
    @media ${media.lgUp} {
      padding: 0 0 36px;
      padding-inline-end: 16px;
    }
  }
  .country-select {
    display: none;
  }
  .iti__selected-dial-code {
    color: var(--grey-4);
  }
  .secondary {
    .iti__arrow {
      border-inline-start: 3px solid transparent;
      border-inline-end: 3px solid transparent;
      border-top: 4px solid var(--white);
      &.iti__arrow--up {
        border-top: none;
        border-bottom: 4px solid var(--white);
      }
    }
    .country-select {
      background: var(--accent-1);
    }
    .iti__selected-dial-code {
      color: var(--white);
    }
  }
  .iti--allow-dropdown {
    width: 85px;
  }
  .iti__selected-dial-code {
    font-weight: 500;
  }
  .iti__country-list {
    margin-top: 15px;
  }
  .form--variant--white {
    .react-select__placeholder {
      color: var(--grey-3) !important;
    }
    .react-select__single-value {
      color: var(--white) !important;
    }
    .form--element--placeholder {
      color: var(--grey-3) !important;
    }
  }
`;

const locations = {
  en: [
    { value: 'France', label: 'France' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Netherlands', label: 'Netherlands' },
    { value: 'Poland', label: 'Poland' },
    { value: 'Portugal', label: 'Portugal' },
    { value: 'Spain', label: 'Spain' },
  ],
  uae: [{ value: 'Dubai', label: 'Dubai' }],
  kuwait: [{ value: 'Kuwait City', label: 'Kuwait City' }],
  saudi_arabia: [{ value: 'Riyadh', label: 'Riyadh' }],
  'ar-ae': [{ value: 'Dubai', label: 'دبي' }],
  'ar-kw': [{ value: 'Kuwait City', label: 'مدينة الكويت' }],
  'ar-sa': [{ value: 'Riyadh', label: 'الرياض' }],
  cs: [{ value: 'Warsaw (Warszawa)', label: 'Warsaw (Warszawa)' }],
  de: [{ value: 'Amsterdam', label: 'Amsterdam' }],
  nl: [{ value: 'Amsterdam', label: 'Amsterdam' }],
  fr: [
    { value: 'Paris', label: 'Paris' },
    { value: 'Lille', label: 'Lille' },
    { value: 'Marseille', label: 'Marseille' },
    { value: 'Lyon', label: 'Lyon' },
  ],
  hu: [{ value: 'Warsaw (Warszawa)', label: 'Warsaw (Warszawa)' }],
  it: [{ value: 'Milano', label: 'Milano' }],
  pl: [{ value: 'Warsaw (Warszawa)', label: 'Warsaw (Warszawa)' }],
  pt: [{ value: 'Lisboa', label: 'Lisboa' }],
  es: [
    { value: 'Barcelona', label: 'Barcelona' },
    { value: 'Madrid', label: 'Madrid' },
  ],
};

const countryCodes = [
  'de',
  'gb',
  'cz',
  'es',
  'de',
  'fr',
  'hu',
  'it',
  'nl',
  'pl',
  'pt',
  'kw',
  'sa',
  'ae',
];

function getInitialCountry(siteTag, langKey) {
  switch (siteTag) {
    case 'cookcity':
      if (countryCodes.includes(langKey)) return langKey;
      return 'pt';

    case 'cooklane':
      if (countryCodes.includes(langKey)) return langKey;
      return 'fr';

    case 'dishmix':
      if (countryCodes.includes(langKey)) return langKey;
      return 'nl';

    case 'foodstars':
      return 'gb';

    case 'kitchenpark':
      if (countryCodes.includes(langKey)) return langKey;
      switch (langKey) {
        case 'ar-sa':
          return 'sa';
        case 'ar-kw':
          return 'kw';
        case 'ar-ae':
          return 'ae';
        default:
          return 'ae';
      }

    case 'pedidoslab':
      if (countryCodes.includes(langKey)) return langKey;
      return 'es';

    default:
      if (countryCodes.includes(langKey)) return langKey;
      return 'gb';
  }
}

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.iti;
  }

  componentDidMount() {
    const { siteTag, langKey } = this.props;
    const { prefixId } = this.props;

    // Flag + Country picker scripts
    window.intlTelInput = intlTelInput;
    const input = document.querySelector(`.${prefixId}-country-select`);

    this.iti = window.intlTelInput(input, {
      initialCountry: getInitialCountry(siteTag, langKey),
      separateDialCode: true,
    });
  }

  // Keep the country code in sync with the language
  componentDidUpdate(prevProps) {
    if (this.props.langKey !== prevProps.langKey) {
      const { siteTag, langKey } = this.props;
      this.iti.setCountry(getInitialCountry(siteTag, langKey));
    }
  }

  inputFocus = (e) => {
    const { id } = e.currentTarget.dataset;
    const parent = document.querySelector(
      `${this.props.parentId} .form--element[data-id=${id}]`
    );
    parent.classList.add('focus');
  };

  inputType = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
    const current = e.currentTarget;
    const text = current.innerHTML;
    const { id } = current.dataset;
    const parent = document.querySelector(
      `${this.props.parentId} .form--element[data-id=${id}]`
    );
    const border = document.querySelector(
      `${this.props.parentId} .form--element--border[data-id=${id}]`
    );
    if (text) {
      parent.classList.remove('done');
      parent.classList.add('active');
      const width = current.clientWidth;
      border.style.width = `${width + 24}px`;
    } else {
      parent.classList.remove('active');
      border.style.width = '0px';
    }
  };

  required = ($type, $name) => {
    const { translate: t } = this.props;
    const holder = document.querySelector(
      `${this.props.parentId} .form--element[data-id="${$type}"]`
    );
    const label = document.querySelector(
      `${this.props.parentId} .form--element[data-id="${$type}"] .form--element--label`
    );
    holder.classList.add('focus');
    holder.classList.add('error');
    label.innerHTML = `${t($name)} ${t('is_required')}`;
  };

  resetLabel = ($type, $name) => {
    console.log($type, $name);
    const { translate: t } = this.props;

    const holder = document.querySelector(
      `${this.props.parentId} .form--element[data-id="${$type}"]`
    );
    const label = document.querySelector(
      `${this.props.parentId} .form--element[data-id="${$type}"] .form--element--label`
    );
    holder.classList.remove('error');
    label.innerHTML = t($name);
  };

  getCountry = () => {
    const { langKey, siteTag } = this.props;

    const countries = {
      'ar-ae': 'UAE',
      'ar-kw': 'Kuwait',
      'ar-sa': 'Saudi Arabia',
      cs: 'Poland',
      de: 'Germany',
      hu: 'Poland',
      nl: 'Netherlands',
      fr: 'France',
      it: 'Italy',
      pl: 'Poland',
      pt: 'Portugal',
      es: 'Spain',
      en: 'United Kingdom',
    };

    if (siteTag === 'foodstars') return countries.en;

    switch (langKey) {
      case 'en':
        switch (siteTag) {
          case 'citychefs':
            return this.props.country;
          case 'dishmix':
            return countries.nl;
          case 'cookcity':
            return countries.pl;
          case 'cooklane':
            return countries.fr;
          case 'kitchenpark':
            return this.props.country;
          default:
            return countries.en;
        }
      default:
        return countries?.[langKey] ?? countries.en;
    }
  };

  getLocationsFor = () => {
    const { langKey, siteTag } = this.props;

    if (langKey === 'en' && siteTag === 'cooklane') {
      return locations['fr'];
    } else if (langKey === 'en' && siteTag === 'dishmix') {
      return locations['nl'];
    } else if (langKey === 'en' && siteTag === 'cookcity') {
      return locations['pl'];
    } else if (langKey === 'en' && siteTag === 'kitchenpark') {
      if (this.props.country !== undefined) {
        return locations[this.props.country.toLowerCase().replace(' ', '_')];
      }
      return;
    } else {
      return locations[`${langKey}`];
    }
  };

  getCityFromLocation = (location) => {
    const { langKey, siteTag } = this.props;
    if (siteTag === 'citychefs' && langKey === 'en') {
      if (this.props.country === 'Portugal') {
        return 'Lisbon';
      } else if (this.props.country === 'Italy') {
        return 'Milano';
      }
    }
    return location;
  };

  form1Click = (e) => {
    if (e) e.preventDefault();
    const { langKey, siteTag } = this.props;

    if (!validator.isLength(this.props.firstName, { min: 1, max: undefined })) {
      this.required(`${this.props.prefixId}-first-name`, 'first_name');
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-first-name`, 'first_name');

    if (!validator.isLength(this.props.lastName, { min: 1, max: undefined })) {
      this.required(`${this.props.prefixId}-last-name`, 'last_name');
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-last-name`, 'last_name');

    if (!validator.isLength(this.props.phone, { min: 1, max: undefined })) {
      // if (!validator.isMobilePhone(this.props.phone, ['en-US'])) {
      this.required(`${this.props.prefixId}-phone`, 'contact_number');
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-phone`, 'contact_number');

    if (!validator.isLength(this.props.company, { min: 1, max: undefined })) {
      this.required(`${this.props.prefixId}-company`, 'company_name');
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-company`, 'company_name');

    if (!validator.isEmail(this.props.email)) {
      this.required(`${this.props.prefixId}-email`, 'email');
      return false;
    }
    this.resetLabel(`${this.props.prefixId}-email`, 'email');

    if (langKey === 'en' && siteTag === 'citychefs') {
      if (
        !validator.isLength(this.props.country, {
          min: 1,
          max: undefined,
        })
      ) {
        this.required(`${this.props.prefixId}-country`, 'preferred_country');
        return false;
      }
      this.resetLabel(`${this.props.prefixId}-country`, 'preferred_country');
    } else {
      if (
        !validator.isLength(this.props.locations, {
          min: 1,
          max: undefined,
        })
      ) {
        this.required(
          `${this.props.prefixId}-locations`,
          'preferred_locations'
        );
        return false;
      }
      this.resetLabel(
        `${this.props.prefixId}-locations`,
        'preferred_locations'
      );
    }

    const accept =
      document.querySelector(`#${this.props.prefixId}-accept-terms:checked`) !==
      null;
    const acceptLabel = document.querySelector(
      `.${this.props.prefixId}-form--element--terms`
    );

    if (!accept) {
      acceptLabel.classList.add('error');
      return false;
    }
    acceptLabel.classList.remove('error');

    const postUrl =
      'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';

    const { utmSource, utmCampaign, utmMedium, utmTerm, utmContent } =
      getUTMParam();
    const { gclid } = getGCLIDParam();
    const dialNum = document
      .querySelector(
        `.country--holder[data-id=${this.props.prefixId}-country] .iti__selected-dial-code`
      )
      .innerText.trim();

    //const [first_name, ...lastName] = this.props.fullName.split(' ');

    const body = {
      oid: '00Df4000003jvM8',
      '00N5G00000V8EjA': utmSource,
      '00N5G00000V8Ej7': utmCampaign,
      '00N5G00000V8Ej9': utmMedium,
      '00N5G00000V8EjB': utmTerm,
      '00N5G00000V8Ej8': utmContent,
      '00Nf400000UWoqU': this.getCountry(),
      '00Nf400000Nk64e': this.getCityFromLocation(this.props.locations), // Kitchen City
      '00Nf400000UVpl3': location.search, // lead_source_detail
      '00Nf400000NjgbXEAR': this.props.comments,
      // '00N5G00000VKzbd': this.props.locations, // Location
      lead_source: 'Inbound: Website',
      lead_source_detail: '00Nf400000UVpl3',
      first_name: this.props.firstName,
      last_name: this.props.lastName,
      phone: `${dialNum} ${this.props.phone.trim()}`,
      company: this.props.company,
      email: this.props.email,
      // debug: 1,
      // debugEmail: 'jesse.goodnoe@cloudkitchens.com',
      GCLID__c: gclid,
      UTM_Campaign__c: utmCampaign,
      UTM_Content__c: utmContent,
      UTM_Medium__c: utmMedium,
      UTM_Source__c: utmSource,
      UTM_Term__c: utmTerm,
    };

    const encode = (data) =>
      Object.keys(data)
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&');

    fetch(postUrl, {
      method: 'post',
      mode: 'no-cors',
      body: encode(body),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
      .then(() => {
        const form1 = document.querySelector(`${this.props.parentId} .form-1`);
        const form2 = document.querySelector(`${this.props.parentId} .form-2`);
        form1.classList.remove('is-active');
        form2.classList.add('is-active');

        if (this.props.parentId === '#modal--contact') {
          const modal = document.getElementById('modal--contact');
          modal.scrollTo(0, 0);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'formSubmit',
          form_step: 'success',
        });

        // google conversions
        window.dataLayer.push({
          event: 'form_complete',
          enhanced_conversion_data: {
            email: body.email,
            phone_number: body.phone,
          },
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  radioLabel = () => {
    const label = document.querySelector('.label--radio');
    label.classList.remove('color--grey-4');
    label.classList.add('color--grey-6');
    const valuesArray = document.querySelectorAll(
      `${this.props.parentId} input[name="orders[]"]:checked`
    );
    let valueString = '';
    for (const checkbox of valuesArray) {
      valueString += `${checkbox.value};`;
    }
    this.props.stateHandler({ orders: valueString.slice(0, -1) });
  };

  inputReset = (e) => {
    const current = e.currentTarget;
    const text = current.innerHTML;
    const { id } = current.dataset;
    const parent = document.querySelector(
      `${this.props.parentId}  .form--element[data-id=${id}]`
    );
    const border = document.querySelector(
      `${this.props.parentId}  .form--element--border[data-id=${id}]`
    );
    if (!text) {
      parent.classList.remove('done');
      parent.classList.remove('focus');
      parent.classList.remove('active');
      border.style.width = '0px';
    } else {
      parent.classList.add('done');
    }
  };

  handleCountryChange = (countryValue) => {
    const element = document.querySelector(
      `${this.props.parentId}  .form--element--country`
    );
    if (countryValue.value !== '') {
      element.classList.add('is-active');
    } else {
      element.classList.remove('is-active');
    }
    this.props.stateHandler({ country: countryValue.value });
  };

  handleLocationsChange = (locationValue) => {
    const element = document.querySelector(
      `${this.props.parentId}  .form--element--country`
    );
    if (locationValue.value !== '') {
      element.classList.add('is-active');
    } else {
      element.classList.remove('is-active');
    }
    this.props.stateHandler({ locations: locationValue.value });
  };

  handlePreferredLocationsChange = (preferredLocationsValue) => {
    const element = document.querySelector(
      `${this.props.parentId}  .form--element--preferred-locations`
    );
    if (preferredLocationsValue.value !== '') {
      element.classList.add('is-active');
    } else {
      element.classList.remove('is-active');
    }
    this.props.stateHandler({ locations: preferredLocationsValue.value });
  };

  render() {
    const { langKey, translate: t, siteTag } = this.props;

    const formElementClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element secondary'
        : 'form--element';
    const formElementTAClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element text-area--height secondary'
        : 'form--element text-area--height';
    const selectClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--select color--white'
        : 'form--element--select';
    const labelClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--label color--white'
        : 'form--element--label';
    const textClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--text color--white'
        : 'form--element--text';
    const textAreaClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--text text-area color--white'
        : 'form--element--text text-area';
    const placeholderClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--placeholder secondary'
        : 'form--element--placeholder';
    const borderClassName =
      // this.props.parentId === '#block-hero-form'
      this.props.color === 'white'
        ? 'form--element--border color--white'
        : 'form--element--border';

    return (
      <Section>
        <div
          className={cx('form-1 is-active', {
            'form--variant--white': this.props.color === 'white',
          })}>
          <div
            className={formElementClassName}
            data-id={`${this.props.prefixId}-first-name`}>
            <label className={labelClassName}>{t('first_name')}</label>
            <div
              className={textClassName}
              contentEditable="true"
              spellCheck="false"
              data-id={`${this.props.prefixId}-first-name`}
              onFocus={this.inputFocus}
              onKeyDown={this.inputType}
              onBlur={this.inputReset}
              onKeyUp={(e) => {
                this.props.stateHandler({
                  firstName: e.target.innerText.trim(),
                });
              }}
            />
            <div className={placeholderClassName}>{t('first_name')}</div>
            <div
              className={borderClassName}
              data-id={`${this.props.prefixId}-first-name`}
            />
          </div>

          <div
            className={formElementClassName}
            data-id={`${this.props.prefixId}-last-name`}>
            <label className={labelClassName}>
              {siteTag === 'foodstars' ? t('surname') : t('last_name')}
            </label>
            <div
              className={textClassName}
              contentEditable="true"
              spellCheck="false"
              data-id={`${this.props.prefixId}-last-name`}
              onFocus={this.inputFocus}
              onKeyDown={this.inputType}
              onBlur={this.inputReset}
              onKeyUp={(e) => {
                this.props.stateHandler({
                  lastName: e.target.innerText.trim(),
                });
              }}
            />
            <div className={placeholderClassName}>
              {siteTag === 'foodstars' ? t('surname') : t('last_name')}
            </div>
            <div
              className={borderClassName}
              data-id={`${this.props.prefixId}-last-name`}
            />
          </div>

          <div className="flex rtl:flex-row-reverse">
            <div
              className={`country--${formElementClassName} country--holder`}
              data-id={`${this.props.prefixId}-country`}>
              <div dir="auto">
                <input
                  className={`${this.props.prefixId}-country-select country-select`}
                />
              </div>
            </div>
            <div
              className={formElementClassName}
              data-id={`${this.props.prefixId}-phone`}>
              <label className={labelClassName}>{t('contact_number')}</label>
              <div
                className={textClassName}
                contentEditable="true"
                spellCheck="false"
                data-id={`${this.props.prefixId}-phone`}
                onFocus={this.inputFocus}
                onKeyDown={this.inputType}
                onBlur={this.inputReset}
                onKeyUp={(e) => {
                  this.props.stateHandler({
                    phone: e.target.innerText.trim(),
                  });
                }}
              />
              <div className={placeholderClassName}>{t('contact_number')}</div>
              <div
                className={borderClassName}
                data-id={`${this.props.prefixId}-phone`}
              />
            </div>
          </div>

          <div
            className={formElementClassName}
            data-id={`${this.props.prefixId}-company`}>
            <label className={labelClassName}>{t('company_name')}</label>
            <div
              className={textClassName}
              contentEditable="true"
              spellCheck="false"
              data-id={`${this.props.prefixId}-company`}
              onFocus={this.inputFocus}
              onKeyDown={this.inputType}
              onBlur={this.inputReset}
              onKeyUp={(e) => {
                this.props.stateHandler({
                  company: e.target.innerText.trim(),
                });
              }}
            />
            <div className={placeholderClassName}>{t('company_name')}</div>
            <div
              className={borderClassName}
              data-id={`${this.props.prefixId}-company`}
            />
          </div>

          <div
            className={formElementClassName}
            data-id={`${this.props.prefixId}-email`}>
            <label className={labelClassName}>{t('email')}</label>
            <div
              className={textClassName}
              contentEditable="true"
              spellCheck="false"
              data-id={`${this.props.prefixId}-email`}
              onFocus={this.inputFocus}
              onKeyDown={this.inputType}
              onBlur={this.inputReset}
              onKeyUp={(e) => {
                this.props.stateHandler({ email: e.target.innerText.trim() });
              }}
            />
            <div className={placeholderClassName}>{t('email')}</div>
            <div
              className={borderClassName}
              data-id={`${this.props.prefixId}-email`}
            />
          </div>

          {langKey === 'en' && siteTag === 'citychefs' && (
            <div
              className="form--element form--element--country"
              data-id={`${this.props.prefixId}-country`}>
              <label className={labelClassName}>{t('preferred_country')}</label>
              <Select
                className={selectClassName}
                classNamePrefix="react-select"
                id={`${this.props.prefixId}-country`}
                name="country"
                placeholder={t('preferred_country')}
                isSearchable={false}
                isClearable={false}
                cache={false}
                onChange={this.handleCountryChange}
                options={[
                  { value: 'Italy', label: 'Italy' },
                  { value: 'Portugal', label: 'Portugal' },
                ]}
              />
            </div>
          )}

          {langKey === 'en' && siteTag === 'kitchenpark' && (
            <div
              className="form--element form--element--country"
              data-id={`${this.props.prefixId}-country`}>
              <label className={labelClassName}>{t('preferred_country')}</label>
              <Select
                className={selectClassName}
                classNamePrefix="react-select"
                id={`${this.props.prefixId}-country`}
                name="country"
                placeholder={t('preferred_country')}
                isSearchable={false}
                isClearable={false}
                cache={false}
                onChange={this.handleCountryChange}
                options={[
                  { value: 'UAE', label: 'UAE' },
                  { value: 'Kuwait', label: 'Kuwait' },
                  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
                ]}
              />
            </div>
          )}

          {siteTag === 'foodstars' && (
            <div
              className="form--element form--element--country"
              data-id={`${this.props.prefixId}-locations`}>
              <label className={labelClassName}>
                {t('preferred_locations')}
              </label>
              <Select
                className={selectClassName}
                classNamePrefix="react-select"
                id={`${this.props.prefixId}-country`}
                name="country"
                placeholder={t('preferred_locations')}
                isSearchable={false}
                isClearable={false}
                cache={false}
                onChange={this.handleLocationsChange}
                options={[
                  { value: 'London', label: 'London' },
                  {
                    value: 'Birmingham',
                    label: 'Birmingham',
                  },
                  { value: 'Manchester', label: 'Manchester' },
                ]}
              />
            </div>
          )}

          {(langKey !== 'en' || siteTag !== 'citychefs') &&
            siteTag !== 'foodstars' && (
              <div
                className="form--element form--element--preferred-locations"
                data-id={`${this.props.prefixId}-locations`}>
                <label className={labelClassName}>
                  {t('preferred_locations')}
                </label>
                <Select
                  className={selectClassName}
                  classNamePrefix="react-select"
                  id={`${this.props.prefixId}-preferredLocation`}
                  name="locations"
                  placeholder={t('preferred_locations')}
                  isSearchable={false}
                  isClearable={false}
                  cache={false}
                  onChange={this.handlePreferredLocationsChange}
                  options={this.getLocationsFor()}
                />
              </div>
            )}

          <div
            className={formElementTAClassName}
            data-id={`${this.props.prefixId}-comments`}>
            <label className={labelClassName}>
              {t('specific_questions_or_comments')}
            </label>
            <div
              className={textAreaClassName}
              contentEditable="true"
              spellCheck="false"
              data-id={`${this.props.prefixId}-comments`}
              onFocus={this.inputFocus}
              onKeyDown={this.inputType}
              onBlur={this.inputReset}
              onKeyUp={(e) => {
                this.props.stateHandler({
                  comments: e.target.innerText.trim(),
                });
              }}
            />
            <div className={placeholderClassName}>
              {t('specific_questions_or_comments')}
            </div>
            <div
              className={borderClassName}
              data-id={`${this.props.prefixId}-comments`}
            />
          </div>

          <div
            className={`form--element--terms ${this.props.prefixId}-form--element--terms relative mt-8`}>
            <input
              style={{ position: 'absolute' }}
              className="form--element--terms--checkbox top-0"
              id={`${this.props.prefixId}-accept-terms`}
              type="checkbox"
              name="accept-terms"
              value="true"
            />
            <label
              htmlFor={`${this.props.prefixId}-accept-terms`}
              className={`form--element--label-small ps-5
                  ${
                    // this.props.parentId === '#block-hero-form'
                    this.props.color === 'white'
                      ? 'color--white'
                      : 'color--grey-5'
                  }
                `}>
              {t('i_have_read_and_understood')}{' '}
              <a
                className="underline"
                href={`/${langKey}/privacy-policy`}
                target="_blank"
                rel="noreferrer">
                {t('privacy_policy')}
              </a>{' '}
              {t('and')}{' '}
              <a
                className="underline"
                href={`/${langKey}/cookies-policy`}
                target="_blank"
                rel="noreferrer">
                {t('cookie_policy')}
              </a>
              {langKey === 'nl' && (
                <>gelezen en begrepen, en ga ermee akkoord.</>
              )}
            </label>
          </div>

          <Button
            variant={this.props.color === 'white' ? 'inverse' : 'primary'}
            onClick={this.form1Click}
            className={cx({
              'mt-12': this.props.parentId === '#block-hero-form',
              'mb-0 mt-8': !(this.props.parentId === '#block-hero-form'),
              'mb-0 mt-8 md:mb-12': this.props.parentId === '#contact-right',
            })}>
            {t('submit')}
          </Button>
        </div>

        <div
          className={`form-2 ${
            // this.props.parentId === '#block-hero-form'
            this.props.color === 'white'
              ? 'md:pb-14 md:ps-14 md:pt-14 lg:p-16'
              : ''
          }`}>
          <p
            className={`h3 contact-thank-you mb-6 ${
              // this.props.parentId === '#block-hero-form'
              this.props.color === 'white' ? 'color--white' : 'color--main'
            }`}>
            {t('thanks_for_contacting_us')}
          </p>
          <p
            className={`mb-12 md:mb-5 ${
              // this.props.parentId === '#block-hero-form'
              this.props.color === 'white' ? 'color--white' : ''
            }`}>
            {t('well_reach_out_shortly')}
          </p>
        </div>
      </Section>
    );
  }
}
export default ContactForm;
